/* eslint-disable import/prefer-default-export */
export const loaded = state => state.loaded;
export const account = state => state.account;
